import { Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";

interface Props {
  header: JSX.Element;
  body: JSX.Element;
  ref?: React.MutableRefObject<any>;
  type: "aggregate" | "portfo";
}

const Table: React.FC<Props> = ({ type, header, body, ref }) => {
  return (
    <MuiTable stickyHeader className="relative min-h-[100px]" ref={ref}>
      <TableHead>
        <tr className="border-0 border-b-2 border-blue-100 !bg-sky-50">
          <td className="border-0 border-l-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100">آتی</td>
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-l-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-blue-100">اختیار</td>
          <td className="border-0 border-b-2 border-blue-100" />
          <td className="border-0 border-b-2 border-l-2 border-blue-100" />
        </tr>
        <TableRow>{header}</TableRow>
      </TableHead>
      <TableBody>{body}</TableBody>
    </MuiTable>
  );
};

export default Table;
